var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgItalic = function SvgItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 13,
    viewBox: "0 0 7 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007faf",
    fillRule: "evenodd",
    d: "M3.464 12 5.816 1.328H3.544L1.192 12z"
  })));
};
export default SvgItalic;